import React from "react";
import { Box, Card, Skeleton } from "@mui/material";

/** Placeholder card shown while the first page is in flight. */
export function ArticleSkeleton() {
  return (
    <Card sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <Skeleton variant="rectangular" sx={{ width: "100%", aspectRatio: "16 / 9" }} />
      <Box sx={{ p: 2, display: "flex", flexDirection: "column", gap: 1 }}>
        <Skeleton variant="text" height={22} />
        <Skeleton variant="text" height={22} width="72%" />
        <Skeleton variant="text" height={16} width="95%" />
        <Skeleton variant="text" height={16} width="55%" />
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, pt: 1 }}>
          <Skeleton variant="circular" width={20} height={20} />
          <Skeleton variant="text" height={14} width="45%" />
        </Box>
      </Box>
    </Card>
  );
}

export function ArticleSkeletonGrid({ count = 9 }: { count?: number }) {
  return (
    <>
      {Array.from({ length: count }, (_, index) => (
        <ArticleSkeleton key={index} />
      ))}
    </>
  );
}
